import { useEffect, useState } from "react"
import dayjs from 'dayjs';

import { filterIntegralByHolders, getEventIntegralTickState, getEventIntegralTickValue, loadEventIntegral, parseEventIntegral } from "./utils";
import References from "../../helpers/Reference";
import { ArrowDownOutlined, CaretDownOutlined, CaretLeftFilled, CaretRightOutlined, CaretUpOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { useStationFilter } from "../SearchStation/store";

const INTERVAL_MINUTE = 10;
const INTERVAL_STEP = 1440 / INTERVAL_MINUTE;

const INTERVAL_FOOTER = 60;
const INTERVAL_FOOTER_STEP = 1440 / INTERVAL_FOOTER;

const NOW_DAY = Date.now();
const DAY_TICK_AMOUNT = 6;

const TIMER_REFRESH = 60;   //in seconds

var timerRefresh = null;

export const EventIntegral = ({holders, onClose}) => {

    const [loading, setLoading] = useState( true );

    const [day, setDay] = useState(dayjs(NOW_DAY).startOf('day'));
    const [dayTick, setDayTick] = useState(0);

    const [allEventIntegralData, setAllEventIntegralData] = useState({})
    const [eventIntegralData, setEventIntegralData] = useState({});

    const [expandedMCH, setExpandedMCH] = useState([]);

    const holdersFilter = useStationFilter()

    const updateEventIntegral = (day, isHideLoading) => {
        setLoading(!isHideLoading);
        loadEventIntegral(day)
        .then((data) => {        
            setAllEventIntegralData(parseEventIntegral( data ));
            setEventIntegralData(parseEventIntegral( filterIntegralByHolders( holdersFilter?.areas, data )));
        })
        .catch(
            (error) => {
                console.log(error.message)
            }
        )
        .finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        const dayShow = new Date(day).toLocaleString(References.locale);
        updateEventIntegral(dayShow);

        timerRefresh = setInterval(updateEventIntegral, TIMER_REFRESH * 1000, dayShow, true);            

        return () => {
            clearInterval(timerRefresh);
        }
    }, []);

    const onPrevDayTick = () => {
        const tick = dayTick + 1;
        const newDay = dayjs(day).subtract(1, 'day')                 

        setDayTick(tick);
        setDay(newDay);
        updateEventIntegral(
            new Date(newDay).toLocaleString(References.locale),             
        );       
        clearInterval(timerRefresh);                
    }

    const onNextDayTick = () => {
        const tick = dayTick - 1;
        const newDay = dayjs(day).add(1, 'day') 
        setDayTick(tick);
        setDay(newDay);
        updateEventIntegral(
            new Date(newDay).toLocaleString(References.locale),             
        );        
        //если текущий день, то включаем автообновление
        if (tick === 0)
            timerRefresh = setInterval(updateEventIntegral, TIMER_REFRESH * 1000, newDay, true);                       
    }

    function onExpandMCHClick( mch ) {    
        let expand = expandedMCH;        
        const index = expand.indexOf(mch);        
        if (expand.length === 0)
            expand = [mch === 'waterlevel' ? 'waterlevel' : 'precipitation'];
            //expand.push(mch === 'waterlevel' ? 'waterlevel' : 'precipitation');
        else if (expand.length === 1) {
            if (index === -1) {
                expand = ['waterlevel', 'precipitation']
            }
            else
                expand = [];
        } else {
            expand = mch === 'waterlevel' ? ["precipitation"] : ["waterlevel"];
        }
        setExpandedMCH(expand);
    }

    return (
        <div id="event-integral">
            <div className="wrapper">
                <div className="modal">
                    <span className="close" onClick={onClose}>&times;</span>
                    <div className="event-integral-dates">
                        {dayTick < DAY_TICK_AMOUNT && <div className="event-integral-date-prev cursor-pointer"><CaretLeftFilled onClick={onPrevDayTick}/></div>}
                        <div className="event-integral-date">{`${dayjs(day).format('DD')} ${References.dictionary.monthes_case[dayjs(day).month()]} ${dayjs(day).year()}`}</div>
                        {dayTick > 0 && <div className="event-integral-date-next cursor-pointer"><CaretRightOutlined onClick={onNextDayTick}/></div>}
                    </div>

                    <div className="event-integral-table">
                    {loading &&
                        <div className="loading"></div>
                    }   
                    {References.event.situation.map((mch) => {
                    const IsHasCriteria = References.event.show_criteria.indexOf(mch) !== -1;                                                                    
                    return (                        
                        <div className="event-integral-item" key={`event-integral-${mch}`}>
                            <h3 className="event-integral-title">
                                {References.mchs[mch]?.name} 
                                <span className="cursor-pointer ml-2">
                                    {expandedMCH.indexOf(mch) !== -1 ? (
                                        <CaretDownOutlined 
                                            onClick={() => onExpandMCHClick(mch)}
                                        />
                                    ) : (
                                        <CaretUpOutlined
                                            onClick={() => onExpandMCHClick(mch)}
                                        />
                                    )
                                    }
                                </span>
                            </h3>
                            {expandedMCH.indexOf(mch) === -1 &&
                            <>
                                {Object.keys(eventIntegralData).length > 0 && eventIntegralData.hasOwnProperty(mch) ? (
                                    <table className={IsHasCriteria ? "event-integral-table-criteria" : ""}>  
                                        <tbody>
                                        {Object.entries(eventIntegralData[mch]?.stations)
                                        .map(([s, _]) => {
                                            const station = eventIntegralData[mch]?.stations[s]; 

                                            //таблица с критерями каналов - вывод посложнее
                                            if (IsHasCriteria) 
                                                return (
                                                    <EventIntergalTableBodyWithCriteria 
                                                        day={day}
                                                        station={station}
                                                        mch={mch}
                                                        s={s}
                                                        key={`event-integral-table-body-with-criteria-${s}`}
                                                    />
                                                )
                                                                                
                                            //просто таблица с событиями
                                            return (
                                                <EventIntegralTableBody 
                                                    day={day}
                                                    station={station}
                                                    mch={mch}
                                                    s={s}
                                                    key={`event-integral-table-body-${s}`}
                                                />
                                            )

                                    })}

                                    <EventIntegralTableFooter day={day} mch={mch} IsHasCriteria={IsHasCriteria}/>
                                    
                                    </tbody>
                                    </table>   
                                ) : (
                                    <EventIntegralEmpty day={day}/>                                
                                )}  
                            </>
                            }                       

                        </div>
                        
                    )})}                    
                    </div>
                </div>
            </div>            
        </div>
    )
}

const EventIntegralTableBody = ({station, day, mch, s}) => {
    const eventKey = Object.keys(station?.station_mchs);
    return (                                        
        <tr className="body" key={`event-integral-station-${mch}-${s}`}>                                        
        <td className="event-integral-station">{station.short_name}</td>                                        
        {Array(INTERVAL_STEP).fill('').map((_, idx) => {
            return (
            <td className={getEventIntegralTickState(dayjs(day).add(INTERVAL_MINUTE * idx, 'minute'), station?.station_mchs[eventKey])} key={`event-integral-tick-${mch}-${s}-${idx}`}>
                <EventIntegralPopover 
                    day={day}                                                         
                    event={station?.station_mchs[eventKey]}
                    station={station} 
                    mch={mch} 
                    idx={idx}
                />                                                    
            </td>                                                
            )
        })}
        </tr>                                        
    )    
}

const EventIntergalTableBodyWithCriteria = ({station, day, mch, s}) => {
    const criteriaKeys = Object.keys(station.station_mchs)
    return (criteriaKeys.map((key, idx) => {
        const eventByCriteria = station.station_mchs[key];
        return (
            <tr className="body" key={`event-integral-station-${mch}-${key}`}>
                {idx === 0 &&
                    <td className="event-integral-station" style={{verticalAlign: "top"}}  rowSpan={criteriaKeys.length}>{station.short_name}</td>
                }
                <td className="event-integral-criteria">
                    {References.event.criteria_field.hasOwnProperty(eventByCriteria.criteria) ? References.event.criteria_field[eventByCriteria.criteria].name : eventByCriteria.name}                    
                </td>
                {Array(INTERVAL_STEP).fill('').map((_, idx) => {
                    return (
                        <td className={getEventIntegralTickState(dayjs(day).add(INTERVAL_MINUTE * idx, 'minute'), eventByCriteria)} key={`event-integral-tick-${mch}-${s}-${idx}`}>
                            <EventIntegralPopover 
                                day={day} 
                                event={eventByCriteria}
                                station={station} 
                                mch={mch} 
                                idx={idx}
                            />                                                    
                        </td>                                                
                    )
                    })}

            </tr>

        );

    }))
}

const EventIntegralEmpty = ({day}) => {
    return (
        <>
            <div className="text-center rem">{References.dictionary.event_situation_empty}</div>
            <table>
            <tbody>
            <tr className="body-empty">
                <td className="event-integral-station">&nbsp;</td>
                {Array(INTERVAL_STEP).fill('').map((_, idx) => {
                    return <td key={`event-integral-score-empty-${idx}`}>&nbsp;</td>
                })}
            </tr>
            <tr className="event-integral-footer">
                <td>&nbsp;</td>
                {Array(INTERVAL_FOOTER_STEP).fill('').map((_, idx) => {
                    return <td key={`event-integral-score-footer-empty-${idx}`} colSpan={INTERVAL_FOOTER / INTERVAL_MINUTE}>{dayjs(day).add(idx * INTERVAL_FOOTER, 'minute').format('HH:mm')}</td>
                })}
            </tr>
            </tbody>
            </table>   
        </>
    )
}

const EventIntegralPopover = ({day, event, idx, station, mch}) => {

    const value = getEventIntegralTickValue(
        dayjs(day).add(INTERVAL_MINUTE * idx, 'minute'), 
        event,
        mch)

    if (value === null)        
        return <span>
            &nbsp;
        </span>;

    return (
        <Popover
            content={
                <>
                <div className="b">{station.name}</div>
                <div className="mt-2">{value}</div>
                <div className="rem">{dayjs(day).add(INTERVAL_MINUTE * idx, 'minute').format('DD.MM HH:mm')}</div>
                </>
            }
            zIndex={9999}
        >
            &nbsp;
        </Popover>
    );

}

const EventIntegralTableFooter = ({day, mch, IsHasCriteria}) => {
    return (
        <tr className="event-integral-footer">
            {IsHasCriteria && 
                <td>&nbsp;</td>
            }
            <td>&nbsp;</td>
            {Array(INTERVAL_FOOTER_STEP).fill('').map((_, idx) => {
                return <td key={`event-integral-score-${mch}-${idx}`} colSpan={INTERVAL_FOOTER / INTERVAL_MINUTE}>{dayjs(day).add(idx * INTERVAL_FOOTER, 'minute').format('HH:mm')}</td>
            })}
        </tr>
    )

}